/** @jsx h */
import { Component, h, JSX, ComponentChild } from 'preact';
import style from '../index.css';
import { CtaItem } from './cta-item';
import { RootStore } from '../../../../../../common/js/stores/root.store';

interface CtaConfig {
  backgroundColor: string;
  labelColor: string;
  reverseTopBar: boolean;
}

interface CustomStyles {
  topControls: Record<string, string | number>;
  bottomControls: Record<string, string | number>;
}

interface CtaFullscreenControlsProps {
  cta: CtaConfig;
  ctaCloseItem: ComponentChild;
  ctaExpandItem: ComponentChild;
  customStyles: CustomStyles;
  isFadeout: boolean;
  isInterstitialAdUnit: boolean;
  onCtaClick: (e: MouseEvent) => void;
  optOutItem: ComponentChild;
  soundItem: ComponentChild;
}

export class CtaFullscreenControls extends Component<
  CtaFullscreenControlsProps
> {
  render(): JSX.Element {
    const {
      cta,
      ctaCloseItem,
      ctaExpandItem,
      customStyles,
      isFadeout,
      isInterstitialAdUnit,
      onCtaClick,
      optOutItem,
      soundItem
    } = this.props;

    const globalClass = isFadeout
      ? style.fullscreenControlsFadeout
      : style.fullscreenControls;

    const ctaItem = <CtaItem onClick={onCtaClick} cta={cta} />;

    const showOptOut = RootStore.getInstance().controlsStore.shouldDisplayOptOut();

    return (
      <div className={globalClass} id="cta-controls">
        <div
          className={style.fullscreenControlsRow}
          style={{
            ...customStyles.topControls,
            flexDirection: cta.reverseTopBar ? 'row-reverse' : 'row'
          }}
        >
          {soundItem}
          {isInterstitialAdUnit ? ctaCloseItem : ctaExpandItem}
        </div>
        <div
          className={style.fullscreenControlsRow}
          style={customStyles.bottomControls}
        >
          {showOptOut ? optOutItem : <div />}
          {ctaItem}
        </div>
      </div>
    );
  }
}
